"use client";

import { useEffect } from "react";

const ONTWIKKELMODUS = process.env.NODE_ENV !== "production";

// Registreert de service worker uit /public/sw.js.
//
// Alleen in productie. In ontwikkelmodus zou hij de hot reload in de weg zitten:
// een gecachet stuk dev-code houdt een wijziging tegen die net is opgeslagen.
// Zet iemand meldingen aan, dan registreert src/lib/meldingen-client.ts hem daar
// wel - met ?ontwikkel=1, waardoor hij niets cachet.
//
// Deze omgeving schakelt heen en weer tussen demo- en ontwikkelmodus. Een
// service worker die in demomodus is geregistreerd blijft daarna gewoon draaien
// en gaat dev-code cachen. Daarom ruimt dit component in ontwikkelmodus op wat
// er van een demo is blijven staan.
export function ServiceWorkerRegistratie() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    if (ONTWIKKELMODUS) {
      void ruimDemoRestenOp();
      return;
    }

    // Meteen registreren, niet wachten op het load-event. Dat wachten scheelde
    // in theorie wat drukte bij het eerste scherm, maar het is een race: is
    // load al voorbij op het moment dat React dit component tot leven wekt, dan
    // komt de registratie er nooit meer - en dan werken offline en meldingen
    // stilletjes niet. De browser plant dit zelf al met lage prioriteit in.
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Zonder service worker werkt de app gewoon; alleen offline en
      // pushmeldingen niet.
    });
  }, []);

  return null;
}

// Een service worker die in demomodus is geregistreerd cachet /_next/static.
// In ontwikkelmodus zijn dat bestanden die bij elke wijziging veranderen, dus
// dan zie je je eigen aanpassing niet meer terug. Weghalen, inclusief wat hij
// al bewaard had.
async function ruimDemoRestenOp(): Promise<void> {
  try {
    const registraties = await navigator.serviceWorker.getRegistrations();
    const vanDemo = registraties.filter(
      (r) => !(r.active ?? r.waiting ?? r.installing)?.scriptURL.includes("ontwikkel=1"),
    );
    if (vanDemo.length === 0) return;

    await Promise.all(vanDemo.map((r) => r.unregister()));
    if ("caches" in window) {
      const namen = await caches.keys();
      await Promise.all(namen.map((n) => caches.delete(n)));
    }
    // Zonder herladen blijft de pagina die de oude service worker heeft
    // geserveerd op het scherm staan.
    window.location.reload();
  } catch {
    // Lukt het opruimen niet, dan is dat vervelend maar niet fataal.
  }
}
